// src/components/DetalleLoteIndustrial.js
//
// Modal de detalle para Lote Industrial (sublayer 4 de parques: Unidades
// Inmobiliarias). Reutiliza los estilos del modal de parques industriales.

import React, { useEffect, useState } from "react";
import parquesIndustriales from "../services/parquesService";
import CloseIcon from "@mui/icons-material/CloseRounded";
import "./DetalleParqueIndustrial.css";
import "./popup-styles.css";

const fmt = (v) =>
  v === null || v === undefined || v === "" ? "" : String(v).trim();

const fmtNumber = (v) => {
  if (v === null || v === undefined || v === "") return "";
  const n = Number(v);
  return isNaN(n)
    ? String(v)
    : n.toLocaleString("es-PE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
};

const KV = ({ label, value }) => {
  if (!value || value === "-" || String(value).trim() === "") return null;
  return (
    <div className="parq-popup-kv">
      <span className="parq-popup-kv-label">{label}</span>
      <span className="parq-popup-kv-value">{value}</span>
    </div>
  );
};

const Section = ({ title, children }) => {
  const hasContent = React.Children.toArray(children).some((c) => c);
  if (!hasContent) return null;
  return (
    <div className="parq-popup-section">
      <h5 className="parq-popup-section-title">{title}</h5>
      <div className="parq-popup-grid">{children}</div>
    </div>
  );
};

const DetalleLoteIndustrial = ({
  idIntervencion,
  idLoteInfra,
  nombre,
  onClose,
}) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!idIntervencion || !idLoteInfra) return;
    let cancelled = false;
    setLoading(true);
    setData(null);

    parquesIndustriales
      .getDetalleIntervencion(idIntervencion, idLoteInfra)
      .then((response) => {
        if (cancelled) return;
        const item = response?.items?.[0];
        if (!item) {
          setData({});
          setLoading(false);
          return;
        }
        setData({
          etapa: fmt(item.Etapa ?? item.etapa).toUpperCase(),
          area: fmtNumber(item.area ?? item.Area),
          propietario: fmt(item.Empresa_Instalada ?? item.empresa_instalada),
          estatus: fmt(item.Estado_Venta ?? item.estado_venta),
          ocupabilidad: fmt(item.Ocupabilidad ?? item.ocupabilidad),
          zonificacion: fmt(item.Zonificacion ?? item.zonificacion),
          uso: fmt(item.Uso_planificado ?? item.uso),
        });
        setLoading(false);
      })
      .catch(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [idIntervencion, idLoteInfra]);

  return (
    <div className="pdet-card">
      <button
        type="button"
        className="pdet-close"
        onClick={onClose}
        aria-label="Cerrar"
      >
        <CloseIcon style={{ fontSize: 20 }} />
      </button>

      <div className="pdet-card-head">
        <span className="pdet-pill">Lote Industrial</span>
        <h2 className="pdet-title">{nombre || "Lote"}</h2>
      </div>

      <div className="pdet-card-body">
        {loading ? (
          <div className="pdet-loading">Cargando información…</div>
        ) : (
          data && (
            <>
              <Section title="General">
                <KV label="Etapa" value={data.etapa} />
                <KV label="Área (m²)" value={data.area} />
                <KV label="Zonificación" value={data.zonificacion} />
                <KV label="Uso planificado" value={data.uso} />
              </Section>

              <Section title="Estado y ocupación">
                <KV label="Empresa instalada" value={data.propietario} />
                <KV label="Disponibilidad" value={data.estatus} />
                <KV label="Ocupabilidad" value={data.ocupabilidad} />
              </Section>
            </>
          )
        )}
      </div>
    </div>
  );
};

export default DetalleLoteIndustrial;
